import { useConnectivity } from '../lib/connectivity.js';
import { useOutbox } from '../lib/outbox-store.js';

export function OfflineBanner() {
  const online = useConnectivity((s) => s.bridgeOnline);
  const reason = useConnectivity((s) => s.reason);
  const pending = useOutbox((s) => s.orders.length);

  if (online && pending === 0) return null;

  if (!online) {
    return (
      <div className="net-banner offline">
        {reason === 'auth'
          ? 'Spire has disabled the app’s account — K-Dental IT needs to re-enable it. Your login is fine.'
          : 'Spire bridge offline — data may be unavailable.'}
        {pending > 0 ? ` ${pending} order${pending > 1 ? 's' : ''} queued.` : ''}
      </div>
    );
  }
  return (
    <div className="net-banner pending">
      {pending} order{pending > 1 ? 's' : ''} queued — sending…
    </div>
  );
}
